import { render, staticRenderFns } from "./SearchList.vue?vue&type=template&id=fc75fab2&scoped=true&"
import script from "./SearchList.vue?vue&type=script&lang=ts&"
export * from "./SearchList.vue?vue&type=script&lang=ts&"
import style0 from "./SearchList.vue?vue&type=style&index=0&id=fc75fab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc75fab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
